import React from "react";
import { BsFillBookmarkFill } from "react-icons/bs";
import "./book-mark.scss";

export const BookMark = (props: any) => {
    return (
        <div className="bookmark" style={{visibility: props.isBookMarkVisible ? "visible" :"hidden"}}>
            <div className="bookmark-content">
                <span><BsFillBookmarkFill size={24} color="#55e4f2" /></span>
                <span className="bookmark-text">
                    <a href={props.bookLink} target="_blank" rel="noopener noreferrer">
                        Yayınevine git
                    </a>
                </span>
            </div>
        </div>
    )
}